// extracted by mini-css-extract-plugin
export var socialBlock = "socialBlock-module--social-block--f6238";
export var socialHeading = "socialBlock-module--social-heading--393ad";
export var socialIcon = "socialBlock-module--social-icon--1e7f5";
export var socialIcons = "socialBlock-module--social-icons--174d9";